<template>
  <b-card v-if="owner" class="owner-details">
    <div class="card-title d-flex">
      <b-avatar :src="ownerAvatar" size="60px" class="mr-4"></b-avatar>
      <div class="d-flex flex-column justify-content-center">
        <h4>{{ owner.full_name }}</h4>
        <label>Member since {{ ownerMemberSince }}</label>
      </div>
    </div>

    <b-button
      v-if="!isOwner"
      block
      variant="outline-primary"
      class="mt-4"
      @click="onSubmit"
    >
      Send a message
    </b-button>
    <div
      class="owner-details__no d-flex flex-row justify-content-center align-items-center"
    >
      <b-img v-if="ownerNumber" :src="require('@/assets/icons/telephone.svg')">
      </b-img>
      <h5 v-if="ownerNumber">
        {{ ownerNumber }}
      </h5>
      <p
        v-if="ownerNumber"
        @click="toggleNumber"
        :class="{
          disabled: !isAuthenticated
        }"
      >
        {{ showNumber ? 'Hide' : 'Show' }} number
      </p>
    </div>
  </b-card>
</template>
<script>
/**
 * ==================================================================================
 * Owner details
 * ==================================================================================
 **/

import { mapState } from 'vuex'
import dayjs from 'dayjs'
import Job from '@/models/Job'

export default {
  props: {
    job: {
      type: [Job, Object],
      validator: function(value) {
        return value.owner
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isAuthenticated: state => state.auth.isAuthenticated
    }),
    owner() {
      return this.job.owner
    },
    ownerAvatar() {
      return this.owner
        ? this.owner.avatar_permanent_thumb_url ||
            this.owner.avatar_permanent_url
        : ''
    },
    ownerMemberSince() {
      return this.owner && this.owner.created_at
        ? dayjs(this.owner.created_at).year()
        : ''
    },
    ownerLast4Number() {
      let number = this.owner ? this.owner.phone_number : null
      return number ? number.substr(number.length - 4) : null
    },
    ownerNumber() {
      if (!this.owner) return
      return this.owner.phone_number
        ? this.showNumber
          ? this.owner.phone_number
          : '•••• ••• ' + this.ownerLast4Number
        : null
    },

    isOwner() {
      if (!this.owner || !this.user) return false
      return this.owner.id === this.user.id
    }
  },
  data: function() {
    return {
      showNumber: false
    }
  },
  methods: {
    async onSubmit() {
      if (!this.isAuthenticated) {
        this.$emit('not-auth', () => {
          this.onSuccess()
        })
      } else {
        this.onSuccess()
      }
    },

    onSuccess() {
      if (!this.isOwner) {
        this.$emit('send-message')
      }
    },
    toggleNumber() {
      if (!this.isAuthenticated) return
      this.showNumber = !this.showNumber
    }
  }
}
</script>
<style scoped lang="scss">
.owner-details {
  .card-title {
    margin-left: -12.5px;

    h4 {
      font-size: 1.4rem;
      margin-bottom: 5px;
    }

    label {
      font-size: 0.85rem;
      margin-bottom: 0;
      color: #6c6c6c;
    }
  }

  .card-body {
    padding: 1.25rem 2rem 2rem 2rem;
  }

  &__no {
    margin-top: 40px;

    > * {
      font-size: 1.1rem;
      line-height: 1.1rem;
      margin-right: 12.5px;
      margin-bottom: 0;
    }

    > *:last-child {
      margin-right: 0;
    }

    img {
      width: 24px;
    }

    p {
      text-decoration: underline;
      cursor: pointer;
      color: var(--brand-green);
    }

    p.disabled {
      color: var(--input-border-color);
      cursor: not-allowed;
    }
  }
}
</style>
